import { Component, inject } from '@angular/core'
import { AppDownloadService } from '@ftr/api-core'
import { AnchorComponent, IconLegacyComponent } from '@ftr/foundation'

@Component({
  selector: 'ftr-desktop-update-splash',
  templateUrl: 'desktop-update-splash.component.html',
  styleUrls: ['desktop-update-splash.component.css'],
  standalone: true,
  imports: [AnchorComponent, IconLegacyComponent],
})
export class DesktopUpdateSplashComponent {
  private readonly appDownloadService = inject(AppDownloadService)

  readonly downloadUrl = this.appDownloadService.getStandaloneAppLink()
}
